var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#00599c",
    d: "M59.749 48c.446-.773.724-1.644.724-2.426V18.426c0-.782-.277-1.653-.724-2.426L32.036 32Z",
    style: {
      strokeWidth: 0.185858
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004482",
    d: "m34.499 63.413 23.51-13.574c.678-.39 1.294-1.066 1.74-1.839L32.036 32 4.324 48c.446.773 1.062 1.449 1.739 1.84l23.51 13.573c1.355.783 3.572.783 4.926 0",
    style: {
      strokeWidth: 0.185858
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#659ad2",
    d: "M59.75 16c-.447-.773-1.063-1.448-1.74-1.84L34.499.588c-1.354-.783-3.571-.783-4.925 0L6.063 14.16c-1.355.781-2.463 2.701-2.463 4.265v27.148c0 .782.277 1.653.724 2.426l27.712-16Z",
    style: {
      strokeWidth: 0.185858
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.036 50.958C21.583 50.958 13.08 42.453 13.08 32s8.504-18.957 18.957-18.957c6.745 0 13.036 3.63 16.417 9.472l-8.204 4.748a9.52 9.52 0 0 0-8.213-4.742c-5.226 0-9.478 4.252-9.478 9.48 0 5.226 4.252 9.478 9.478 9.478a9.52 9.52 0 0 0 8.214-4.742l8.204 4.747c-3.381 5.844-9.672 9.474-16.418 9.474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.781 35.16h2.106v-2.107h2.107v-2.106h-2.107V28.84h-2.106v2.106h-2.106v2.106h2.106zM54.68 35.16h2.106v-2.107h2.107v-2.106h-2.107V28.84H54.68v2.106h-2.106v2.106h2.106z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c++.67546ee38bb1ab4e7b6e2ed85b80f2fb.svg";
export { ForwardRef as ReactComponent };